import styled from 'styled-components';

import {media} from '~/shared/theme/utils';
import {PriceLabel} from '~/shared/components/PriceLabels';
import {useIsMinDesktop} from '~/shared/hooks/deviceInfo';
import {body18Bold, body16Bold} from '~/shared/theme/typography';

import {Row} from './components/styled';

export const ComponentBySize = ({MobileComponent, DesktopComponent, props}) => {
  const isMinDesktop = useIsMinDesktop();
  return isMinDesktop ? <DesktopComponent {...props} /> : <MobileComponent {...props} />;
};

// header space (to start after the header as it's position fixed)
export const Wrapper = styled.div`
  margin-top: ${({theme}) => theme.newHeader.height.mobile}px;
  min-height: calc(100vh - 147px);
  ${media.minTablet`
    margin-top: 100px;
    min-height: calc(100vh - 250px);
  `}
`;

export const Title = styled.div`
  ${body18Bold}
  margin-bottom: 16px;
  color: ${({theme}) => theme.userReport.transactionTable.background.header};
  ${({isMobile}) => isMobile && `
    ${body16Bold}
  `}
`;

export const lowerCaseFirstLetter = str => str.charAt(0).toLowerCase() + str.slice(1);

export const TotalRow = ({price, label, customTableFooterColor}) => (
  <Row total spaceBetween customTableFooterColor={customTableFooterColor}>
    <div>{label}</div>
    <PriceLabel price={price} bold/>
  </Row>
);
